import { datadogLogs } from '@datadog/browser-logs';

export const { logger } = datadogLogs;

logger.setHandler([
    'console',
    ...(window.location.href.includes('localhost') ? [] : ['http' as const]), // don't send to datadog if localhost
]);
